import TeacherAttendanceManager from '../../components/attendance/TeacherAttendanceManager';

export default function TeacherAttendance() {
  return <TeacherAttendanceManager />;
}
